import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { arrayOf, bool, shape, string } from 'prop-types'
import { converText } from '../../../utils/textSlug'

import {
  BottomLine,
  Content,
  SubmenuNavigation,
  SubmenuNavigationItem,
  SubmenuNavigationList,
  RelativeContainer,
  NavigationLink
} from './styles'

class Submenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentIndex: null,
      bottomLinePosition: 0,
      bottomLineWidth: 0
    }
    this.navigationItems = []
  }

  componentDidMount = () => {
    if (!this.props.secondary) {
      return this.setState({ currentIndex: 0 })
    }

    this.setState({ currentIndex: this.findCurrentIndex() })
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { router, navItems, secondary } = this.props
    const { pathname } = router.location

    const { currentIndex } = this.state

    if (prevProps.history.action === 'POP' && currentIndex === 0) {
      return this.setState({ currentIndex: this.findCurrentIndex() })
    }
    if (prevProps.router.location.pathname !== pathname) {
      if (!secondary && pathname.includes('/instalacao')) {
        return this.setState({ currentIndex: 3 })
      }
      this.setState({ currentIndex: this.findCurrentIndex() })
    }
    if ((currentIndex === null || currentIndex === -1) && prevProps.navItems !== navItems) {
      this.setState({ currentIndex: this.findCurrentIndex() })
    }
  }

  setActiveElement = index => {
    const isClient = typeof window !== 'undefined'
    const activeNavElement = this.navigationItems[index]
    if (activeNavElement && isClient) {
      return {
        bottomLinePosition: activeNavElement.offsetLeft,
        bottomLineWidth: activeNavElement.clientWidth
      }
    }
  }

  findCurrentIndex = () => {
    const { navItems, router } = this.props
    const { pathname } = router.location
    if (router && navItems.length > 0) {
      const endOfLink = link => link && link.split('/')[link.split('/').length - 1]
      return navItems.findIndex(navItem => pathname.indexOf(endOfLink(navItem.link)) !== -1)
    }
  }

  render() {
    const { navItems, lastItemOnRight, secondary } = this.props
    const { currentIndex } = this.state
    const { bottomLinePosition, bottomLineWidth } = this.setActiveElement(currentIndex) || {}
    const gtmLabel = 'item:'

    return (
      <SubmenuNavigation secondary={secondary} lastItemOnRight={lastItemOnRight}>
        <Content>
          <RelativeContainer>
            <SubmenuNavigationList>
              {navItems.map((item, index) => {
                const isActive = index === currentIndex
                return (
                  <SubmenuNavigationItem
                    secondary={secondary}
                    active={isActive}
                    key={item.label}
                    innerRef={el => (this.navigationItems[index] = el)}
                  >
                    <NavigationLink
                      to={item.link}
                      id={item.id}
                      className="gtm-link-event"
                      data-gtm-event-category="veloe:area-logado:geral"
                      data-gtm-event-action="clique:menu-principal"
                      data-gtm-event-label={gtmLabel + converText(item.label)}
                    >
                      {item.label}
                    </NavigationLink>
                  </SubmenuNavigationItem>
                )
              })}
            </SubmenuNavigationList>
            {!secondary && (
              <BottomLine
                style={{
                  left: bottomLinePosition,
                  width: bottomLineWidth
                }}
              />
            )}
          </RelativeContainer>
        </Content>
      </SubmenuNavigation>
    )
  }
}

Submenu.defaultProps = {
  navItems: [],
  secondary: false
}

Submenu.propTypes = {
  secondary: bool,
  navItems: arrayOf(
    shape({
      external: bool,
      label: string,
      link: string,
      id: string
    })
  )
}

export default withRouter(Submenu)



// WEBPACK FOOTER //
// ./src/app/elements/Submenu/Submenu.js